import { Link } from 'react-router-dom';
import { categories } from '@/mocks/categories';

export default function CategorySection() {
  return (
    <section className="py-14 md:py-20 bg-background-50">
      <div className="px-4 md:px-6 max-w-7xl mx-auto">
        <div className="text-center mb-12">
          <h2 className="font-heading text-2xl md:text-4xl font-bold text-foreground-950 mb-4">
            热门<span className="text-primary-500">吃瓜</span>分类
          </h2>
          <p className="text-foreground-500 text-sm md:text-base max-w-xl mx-auto leading-relaxed">
            按你的口味精准吃瓜，六大分类总有一款适合你
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-5">
          {categories.map((cat) => (
            <Link
              key={cat.slug}
              to={`/category/${cat.slug}`}
              className="group bg-background-50 border border-background-200/70 rounded-lg p-5 md:p-6 hover:border-primary-300 transition-all duration-300 cursor-pointer"
            >
              <div className="flex items-start gap-4">
                <div className="w-12 h-12 flex items-center justify-center rounded-md bg-primary-50 text-primary-500 group-hover:bg-primary-500 group-hover:text-background-50 transition-all duration-300 flex-shrink-0">
                  <i className={`${cat.icon} text-xl`}></i>
                </div>
                <div className="flex-1 min-w-0">
                  <div className="flex items-center justify-between mb-1.5">
                    <h3 className="font-heading text-base font-semibold text-foreground-900 group-hover:text-primary-500 transition-colors duration-200">
                      {cat.name}
                    </h3>
                    <span className="text-xs text-foreground-400 bg-background-100 px-2 py-0.5 rounded-full">
                      {cat.count}篇
                    </span>
                  </div>
                  <p className="text-foreground-500 text-sm leading-relaxed">
                    {cat.description}
                  </p>
                </div>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}